<script setup lang="ts">
// Structured Data (Schema.org) - Person & Professional Service
useHead({
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Person',
        name: 'Enrico Reinsdorf',
        jobTitle: 'Senior UX Designer',
        description: 'Senior UX Designer mit Expertise in User Experience Design, Usability Engineering, Design Systems und Product Ownership.',
        url: 'https://re-design.de',
        image: 'https://re-design.de/images/enrico-portrait.jpg',
        email: 'enrico.reinsdorf@re-design.de',
        telephone: '0177-2022447',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Nürnberg',
          addressRegion: 'Bayern',
          addressCountry: 'DE'
        },
        alumniOf: [
          {
            '@type': 'EducationalOrganization',
            name: 'Hochschule Hof',
            url: 'https://www.hof-university.de'
          },
          {
            '@type': 'EducationalOrganization',
            name: 'SAE College'
          }
        ],
        hasCredential: [
          {
            '@type': 'EducationalOccupationalCredential',
            name: 'CPUX-F (Certified Professional for Usability and User Experience - Foundation Level)'
          },
          {
            '@type': 'EducationalOccupationalCredential',
            name: 'CPUX-UT (Certified Professional for Usability and User Experience - Usability Testing)'
          }
        ],
        knowsAbout: [
          'User Experience Design',
          'Usability Engineering',
          'User Research',
          'Design Systems',
          'Product Ownership',
          'Workshop Facilitation',
          'Team Leadership',
          'Agile Development'
        ],
        sameAs: [
          'https://www.linkedin.com/in/enrico-reinsdorf-6b091125',
          'https://re-design.de'
        ]
      })
    },
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'ProfessionalService',
        name: 'Enrico Reinsdorf - UX Design Services',
        description: 'UX Design, Usability Engineering, Design Systems und User Research Services',
        url: 'https://re-design.de',
        telephone: '0177-2022447',
        email: 'enrico.reinsdorf@re-design.de',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Nürnberg',
          addressRegion: 'Bayern',
          addressCountry: 'DE'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: '49.4521',
          longitude: '11.0767'
        },
        areaServed: {
          '@type': 'Country',
          name: 'Deutschland'
        },
        priceRange: '$$',
        serviceType: [
          'User Experience Design',
          'Usability Engineering',
          'Design System Development',
          'User Research',
          'UX Consulting'
        ]
      })
    }
  ]
})
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
